import { z } from "zod";

export const DeletePermissionResponseSchema = z.object({
    code: z.number(),
    message: z.string(),
    success: z.boolean(),
    data: z.nullable(z.any()),
});

export type DeletePermissionResponse = z.infer<typeof DeletePermissionResponseSchema>;